// src/modules/app-views/products/pages/Ai/modals/SettingsModal/index.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useMemo } from 'react';
import { SettingOutlined } from '@ant-design/icons';
import GenericModal from 'components/core/GenericModal';
import appService from 'services/appService';
import translateX from 'utils/translateX';
import settingsModalStep from './Step1';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const SettingsModal = ({
  show,
  setShow,
  afterClose,
  aiBusinessContext,
  aiAssistantProfile,
}) => {
  // ---------------------------------------------------------------------------
  // HANDLERS
  // ---------------------------------------------------------------------------
  const handleFinish = async ({ form }) => {
    try {
      const values = form.getFieldsValue();
      await appService.updateModulePreferences({
        category: 'aiSettings',
        data: { aiAssistantProfile: values.aiAssistantProfile || '' },
      });
      appService.message({ flag: 's', text: translateX('saved_successfully') });
      return true;
    } catch (error) {
      console.error('[SettingsModal] Error saving AI settings:', error);
      appService.message({ flag: 'e', text: translateX('error') });
      return false;
    }
  };

  // ---------------------------------------------------------------------------
  // LOCAL VARIABLES
  // ---------------------------------------------------------------------------
  const steps = useMemo(() => [settingsModalStep()], []);

  // ---------------------------------------------------------------------------
  // UI
  // ---------------------------------------------------------------------------
  return (
    <GenericModal
      show={show}
      setShow={setShow}
      icon={<SettingOutlined />}
      title="ai_settings"
      steps={steps}
      onFinish={handleFinish}
      afterClose={afterClose}
      width={600}
      initialValues={{
        aiBusinessContext: aiBusinessContext || '',
        aiAssistantProfile: aiAssistantProfile || '',
      }}
    />
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default SettingsModal;
